export default {
  TITLE: `Schedule capacity`,
  SUMMARY: ``,
  POSITION: `Position`,
  LAST_UPDATED: `Last updated on {{date}}`,
  NO_DATA_LOADED: `No data loaded`,
  ERROR_LOADING: `Error loading data`,
  LOAD: `Load`,
  ADD_ONE_MONTH: `Add one month`,
  FORCE_RELOAD: `Force recompute`,
  PLANNED: 'Planned shifts',
  PRIMARY_CAPACITY: 'Primary capacity',
  REMAINING_CAPACITY: 'Remaining capacity',
  PRIMARY_DELTA: 'Primary delta',
  TOTAL_DELTA: 'Total delta',
  START_DATE_AFTER_END: `The start date must be before the end date.`,
  DETAIL_MODAL: {
    TITLE: `Schedule capacity detail`,
    SUMMARY: ``,
    ERROR_LOADING: `Error loading scheduled users.`,
    PRIMARY_SCHEDULED: `Primary capacity scheduled ({{ count }})`,
    PRIMARY_UNSCHEDULED: `Primary capacity unscheduled ({{ count }})`,
    TOTAL_SCHEDULED: `Total capacity scheduled ({{ count }})`,
    TOTAL_UNSCHEDULED: `Total capacity unscheduled ({{ count }})`
  },
  filter: {
    START_DATE: `Start date`,
    END_DATE: `End date`,
    POSITIONS: `Positions`,
    REGION: `Region`,
    SCHEDULE_TYPE: `Schedule type`,
    ALL: `All`
  },
  progress: {
    CALCULATING_ATTRIBUTE_MATRICES: 'Calculating attribute matrices',
    CALCULATING_AVAILABILITY: 'Calculating availability',
    SAVING_CAPACITY: 'Saving to database',
    DONE: 'Done'
  },
  export: {
    TITLE: `Export`,
    EXPORT_CSV: 'Export as CSV',
    EXPORT_CSV_DETAILED: 'Export as CSV (Detailed)',
    EXPORT_CSV_SECONDARY_DETAIL: 'Export as CSV (Secondary Occupations)',
    EXPORT_CSV_AVAILABILITY: 'Export as CSV (Availability)',
    EXPORT_CSV_UNSCHEDULED_BUT_ELIGIBLE: 'Export as CSV (Unscheduled but eligible)'
  },
  csv: {
    CSV_DEFAULT_NAME: `export_schedule_capacity_{{ start }}_{{end}}`,
    CSV_AVAILABILITY_NAME: `export_schedule_capacity_availability_{{ start }}_{{end}}`,
    CSV_DETAILED_NAME: `export_schedule_capacity_detailed_{{ start }}_{{end}}`,
    CSV_DETAILED_SECONDARY_NAME: `export_schedule_capacity_detailed_secondary_{{ start }}_{{end}}`,
    CSV_UNSCHEDULED_BUT_AVAILABLE_NAME: `export_schedule_capacity_unscheduled_available_{{ start }}_{{end}}`,
    NOT_ELIGIBLE: `Not eligible`,
    NOT_AVAILABLE_REPORT: `Not available`,
    AVAILABLE_TIME: `Available`,
    PREFERED_TIME: `Preferred time`,
    UNAVAILABLE: `Unavailable`,
    AVAILABLE_ALL_DAY: `Available`
  }
}
